import { render, staticRenderFns } from "./FormDistrict.vue?vue&type=template&id=16a4132d&lang=pug&"
import script from "./FormDistrict.vue?vue&type=script&lang=js&"
export * from "./FormDistrict.vue?vue&type=script&lang=js&"
import style0 from "./FormDistrict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports